export const SEARCH_QUITE_PERIOD = 600;
export enum KEYSTROKE {
  ENTER = 'Enter',
  TAB = 'Tab',
  SHIFT_RIGHT = 'ShiftRight',
  SHIFT_LEFT = 'ShiftLeft',
  ESCAPE = 'Escape'
}
export const PREVENT_KEYUP_EVENTS = /ALT|ARROW|F+|ESC|TAB|SHIFT|CONTROL|PAGE|HOME|PRINT|END|CAPS|AUDIO|MEDIA/i;

export class MiscellaneousUtils {
  /**
   * Gets a new random date.
   * @returns {Date}
   */
  public static getRandomDate(): Date {
    let randomDate = new Date(2000, 1, 1);
    randomDate.setDate(this.getRandomNumber(1, 28));
    randomDate.setMonth(this.getRandomNumber(11, 1));
    randomDate.setFullYear(this.getRandomNumber(2014, 2018));
    return randomDate;
  }

  /**
   * Gets a random number based on the given parameters.
   * @param {number} from
   * @param {number} to
   * @returns {number}
   */
  public static getRandomNumber(from: number, to: number): number {
    return Math.floor(Math.random() * (to - from + 1) + from);
  }

  /**
   * Gets a big random number.
   * @returns {number}
   */
  public static xgetBigRandomNumber(min: number, max: number): number {
    return this.getRandomNumber(300, 15000);
  }

  /**
   * Gets a short random number.
   * @returns {number}
   */
  public static xgetRandomNumber(min: number, max: number): number {
    return this.getRandomNumber(1, 3);
  }

  /**
   * Clones the internal elements of the array to prevent reference issues when modifying elements.
   * TODO: We should use Ramda clone() instead.
   * @param {Array<any>} array
   * @returns {Array<any>}
   */
  public static cloneArray(array: Array<any>): Array<any> {
    let resultArray: Array<any> = [];
    for (let item of array) {
      resultArray.push({ ...(item as any) });
    }
    return resultArray;
  }

  /**
   * Safely accesses object properties
   * @param {any} obj to access properties of
   * @param {string} key string path to desired property
   * @returns {any}
   */
  public static safeAccess(obj: any, key: string): any {
    return key.split('.').reduce((o, x) => {
      return typeof o === 'undefined' || o === null ? o : o[x];
    }, obj);
  }
}
